"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const reducers_1 = require("../reducers");
exports.updateEditableUIState = (newUIStateGroup, newUIStateValue) => (dispatch, getState) => {
    const state = getState();
    const editableUIState = reducers_1.getEditableUIState(state);
    const newEditableUIState = Object.assign(Object.assign({}, editableUIState), { [newUIStateGroup]: Object.assign({}, newUIStateValue) });
    dispatch({
        type: 'UPDATE_EDITABLE_UI_STATE',
        editableUIState: newEditableUIState,
    });
};
